import { Dispatch } from 'redux';
import CrudActionContainer from './CrudActionContainer';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import { SendlaneListsResponse } from '../model/SendlaneModel';
import { sendlaneErrorHandler } from '../errorHandlers/sendlane-handler';
import SendlaneController from '../controllers/SendlaneController';

class SendlaneCRUDActions extends CrudActionContainer {
  retrieveLists: string;
  retrieveApiKeys: string;
  retrievedApiKey: string;
  revokeAction: string;

  constructor() {
    super('SENDLANE');
    this.retrieveLists = this.makeActionKey('RETRIEVED_LISTS');
    this.retrieveApiKeys = this.makeActionKey('RETRIEVED_API_KEYS');
    this.retrievedApiKey = this.makeActionKey('RETRIEVED_API_KEY');
    this.revokeAction = this.makeActionKey('REVOKE');
  }

  getLists(
    facebookPageId: number,
    accessTokenId: number,
    force: boolean = false,
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveLists));
      try {
        const response: SendlaneListsResponse =
          await SendlaneController.getLists(
            facebookPageId,
            accessTokenId,
            force,
          );
        dispatch({
          type: this.retrieveLists,
          lists: response,
        });
        return response;
      } catch (error) {
        sendlaneErrorHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  getApiKeys(facebookPageId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveApiKeys));
      try {
        const response = await SendlaneController.getApiKeys(facebookPageId);
        dispatch({
          type: this.retrieveApiKeys,
          apiKeys: response,
        });
        return response;
      } catch (error) {
        return sendlaneErrorHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  createApiKey(privateKey: string) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.createAction));

        const res = await SendlaneController.createApiKey(privateKey);

        dispatch({ type: this.retrievedApiKey, apiKey: res });

        return res;
      } catch (error) {
        return sendlaneErrorHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  updateApiKey(id: number, privateKey: string) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.createAction));

        const res = await SendlaneController.updateApiKey(id, privateKey);

        dispatch({ type: this.retrievedApiKey, apiKey: res });
        return res;
      } catch (error) {
        return sendlaneErrorHandler(dispatch)(error);
      } finally {
        dispatch(this.unbusy());
      }
    };
  }
}

const sendlaneCRUDActions = new SendlaneCRUDActions();

export default sendlaneCRUDActions;

export const useSendlaneCRUDActions = getActionHookBuilder(
  sendlaneCRUDActions,
  ['getLists', 'getApiKeys', 'createApiKey', 'updateApiKey'],
);
